export type AcessLevelProps = {
	type?: string;
	acessLevel: number;
};

export const SET_ACESS_LEVEL = 'SET_ACESS_LEVEL';
